module.exports = __webpack_public_path__ + "img/video_processo_denuncia.fd1f5080.jpg";